import { sanitiseVueObservable } from "react-migration/domains/sites/pipeline/helpers/sanitiseVueObservable";
import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useSelectedParcelIds = () => {
  const { selectedParcelIds } = useSnapshot(skipTracingStore);

  return sanitiseVueObservable(selectedParcelIds);
};
